// src/pages/AdminLogin.jsx
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate }            from 'react-router-dom';
import NET                        from 'vanta/dist/vanta.net.min';
import * as THREE                 from 'three';
import VanillaTilt                from 'vanilla-tilt';
import '../styles/adminlogin.css';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin`;

export default function AdminLogin() {
  const navigate     = useNavigate();
  const vantaRef     = useRef(null);
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      navigate('/admin');
    }
  }, [navigate]);

  useEffect(() => {
    const effect = NET({
      el: vantaRef.current,
      THREE,
      color:           0xff3860,
      backgroundColor: 0x0f0f1a,
      points:          10.0,
      maxDistance:     20.0,
      spacing:         15.0,
    });
    return () => effect.destroy();
  }, []);

  useEffect(() => {
    VanillaTilt.init(
      document.querySelectorAll('.admin-login-box'),
      { glare: true, 'max-glare': 0.3, speed: 300 }
    );
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    try {
      const res  = await fetch(`${API_URL}/login`, {
        method:  'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json' // เพิ่มบรรทัดนี้
        },
        body:    JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.msg || 'Login failed');
        return;
      }
      localStorage.setItem('adminToken', data.token);
      navigate('/admin');
    } catch (err) {
      console.error(err);
      setError('Network error');
    }
  };

  return (
    <div className="admin-login-page">
      <div ref={vantaRef} id="vantabg" />
      <div className="overlay scanlines" />
      <div className="overlay flicker" />

      <div className="admin-login-box">
        <h2>Admin Login</h2>
        {error && <div className="error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>email</label>
            <input
              type="email"
              placeholder="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>password</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn-login">
            Login as Admin
          </button>
        </form>
      </div>
    </div>
  );
}
